// terrible hack due to untestable reactstrap DOM magic
import BuggyTooltip from '@appfolio/react-gears/lib/components/Tooltip';
const Tooltip =
  process.env.NODE_ENV === 'test' ? () => null as never : BuggyTooltip;

export default Tooltip;
